import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import authReducer from '../features/auth/auth.slice';
import themeReducer from '../features/theme/theme.slice';
import sidebarReducer from '../features/sidebar/sidebar.slice';
import userReducer from '../features/users/users.slice';
import dialogReducer from '../features/dialog/dialog.slice';
import dialogTransactionTabReducer from '../features/dialog/dialog-transaction-tab.slice';
import allAccrualsReducer from '../features/general journal/accruals-all.slice';

import { baseApi } from '../features/base.api';

//notifications
import { statusChequeCountApi } from '../features/notifications/cheque/cheque-count-notification.api';
import { statusTransactionsCountApi } from '../features/notifications/transactions/transactions-count-notification.api';

//dropdowns
import { dropdownEmployeesFromSedarApi } from '../features/dropdown/dropdown-employees-from-sedar.api';

//sync
import { syncDepartmentsFromSedarApi } from '../features/sync/sync-departments-sedar.api';
import { syncUserDataFromSedarApi } from '../features/sync/sync-user-data-sedar';
import { reportApi } from '../features/reports/transaction-reports.api';
import { syncYmicCOAApi } from '../features/sync/sync-ymir-coa';
import { syncOneChargingApi } from '../features/sync/sync-one-charging.api';
import { statusJournalsCountApi } from '../features/notifications/transactions/journal-count-notification.api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    sidebar: sidebarReducer,
    user: userReducer,
    dialog: dialogReducer,
    dialogTransactionTab: dialogTransactionTabReducer,
    allAccruals: allAccrualsReducer,

    [baseApi.reducerPath]: baseApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [syncYmicCOAApi.reducerPath]: syncYmicCOAApi.reducer,
    [syncOneChargingApi.reducerPath]: syncOneChargingApi.reducer,

    [syncOneChargingApi.reducerPath]: syncOneChargingApi.reducer,

    //dropdowns
    [dropdownEmployeesFromSedarApi.reducerPath]: dropdownEmployeesFromSedarApi.reducer,

    //sync
    [syncDepartmentsFromSedarApi.reducerPath]: syncDepartmentsFromSedarApi.reducer,
    [syncUserDataFromSedarApi.reducerPath]: syncUserDataFromSedarApi.reducer,

    //notifications
    [statusChequeCountApi.reducerPath]: statusChequeCountApi.reducer,
    [statusTransactionsCountApi.reducerPath]: statusTransactionsCountApi.reducer,
    [statusJournalsCountApi.reducerPath]: statusJournalsCountApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      [baseApi.middleware],
      [reportApi.middleware],

      //dropdowns
      [dropdownEmployeesFromSedarApi.middleware],

      //sync
      [syncDepartmentsFromSedarApi.middleware],
      [syncUserDataFromSedarApi.middleware],
      [syncYmicCOAApi.middleware],
      [syncOneChargingApi.middleware],

      [syncOneChargingApi.middleware],

      //notifications
      [statusChequeCountApi.middleware],
      [statusTransactionsCountApi.middleware],
      [statusJournalsCountApi.middleware],
    ),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
